module.exports = __webpack_public_path__ + "media/39.51f9f429.mp3";